import React, { FC } from 'react'
import { NoteTableHeaderList, ThreePsCategorizedCodes } from '../../../../../../../Models/applicationModels'
import { GlobalTableStyles } from '../../../../../../../Components/updateApplicationAnalysisResultPopup/noteTable/globalTableStyles'
import { ThreePsCodeTableHeaderList } from '../../../../../../../constants/tableHeaderList'
import styles from './threePsStyles.module.css'
import { Collapse, CollapseProps } from 'antd'
import { RightOutlined } from '@ant-design/icons'
import { getThreePsTableConstant } from './threePsTable.utils'
import { AccordianHeader } from './components/accordianHeader/accordianHeader.index'
import { ExtraElement } from './components/accordianHeader/extraElement.index'

interface ThreePsSectionProps {
    sectionKey: string
    entries: ThreePsCategorizedCodes[]
}

export const ThreePsSection: FC<ThreePsSectionProps> = ({ sectionKey, entries }) => {
    const { label, primaryColor, secondaryColor } = getThreePsTableConstant(sectionKey)
    const { tableStyle, tableHeader, tableCell } = GlobalTableStyles().classes

    const renderedTable = (
        <table className={tableStyle}>
            <thead>
                <tr>
                    {ThreePsCodeTableHeaderList.map((header: NoteTableHeaderList) => (
                        <th
                            key={header.headerName}
                            className={tableHeader}
                            style={{ width: header.width }}
                        >
                            {header.headerName}
                        </th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {entries.map((row, index) => (
                    <tr key={row.code}>
                        <td className={tableCell}>{index + 1}</td>
                        <td className={tableCell}>{row.code}</td>
                        <td className={tableCell}>
                            <p
                                className={styles.accordionHeaderExtraElement}
                                style={{ backgroundColor: secondaryColor, color: primaryColor }}
                            >
                                {row.subCategory}
                            </p>
                        </td>
                        <td className={tableCell}>{row.originalDescription}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    )

    const collapseItems: CollapseProps['items'] = [
        {
            key: sectionKey,
            label: <AccordianHeader label={label || sectionKey} primaryColor={primaryColor} entriesLength={entries.length} />,
            children: renderedTable,
            classNames: {
                header: styles.accordionHeader,
                body: styles.accordionBody,
            },
            styles: {
                header: {
                    backgroundColor: secondaryColor,
                    borderLeft: `4px solid ${primaryColor}`,
                },
            },
            extra: <ExtraElement primaryColor={primaryColor} entriesLength={entries.length} />,
        },
    ]

    return (
        <Collapse
            bordered={false}
            expandIconPlacement="end"
            items={collapseItems}
            className={styles.accordionContainer}
            ghost
            expandIcon={({ isActive }) => (
                <RightOutlined
                    style={{ color: isActive ? primaryColor : '#4A5565' }}
                    rotate={isActive ? -90 : 0}
                />
            )}
        />
    )
}